export default __webpack_public_path__ + "static/SR USA - Powder Caramel Color HACCP - Statement-fa1fad92c2748e58604bd4b4c912c1d1.pdf";